// ===========================================
// konakla - Giriş hatası mesajları
// ===========================================
//
// `/auth?error=<kod>` parametresi DIŞARIDAN gelir ve tamamen saldırgan
// kontrolündedir (kod tabanında bu parametreyi üreten bir yer yok;
// `app/auth/callback/route.ts` hatada temiz `/auth`'a yönlendiriyor). Eşleme
// yalnızca Supabase'in OAuth hata kodlarıyla gelme ihtimaline karşı tutuluyor.
//
// ⚠️ NEDEN `Map`, DÜZ NESNE DEĞİL: bu kod ilk sürümünde düz bir nesne ve
// `MESAJLAR[param] ?? GENEL` kullanıyordu. Düz nesnede köşeli parantez araması
// PROTOTİP ÜYELERİNİ de bulur ve `??` onları yakalamaz (null/undefined
// değiller). Ölçüldü — beş girdi giriş sayfasını düşürüyordu:
//
//     ?error=__proto__      -> Object.prototype  (nesne)
//     ?error=constructor    -> fonksiyon
//     ?error=toString       -> fonksiyon
//     ?error=valueOf        -> fonksiyon
//     ?error=hasOwnProperty -> fonksiyon
//
// React bir nesneyi/fonksiyonu metin olarak basamaz; bileşen hata sınırına
// düşer ve kullanıcı GİRİŞ YAPAMAZ. Yani saldırgan metnini engellemek için
// eklenen sertleştirme, saldırgana sayfayı çökertme yolu açmıştı (O-44'ün
// ilk düzeltmesi). `Map` prototip zincirine hiç bakmaz; sorun kökten kalkar.

const MESAJLAR = new Map<string, string>([
  ["access_denied", "Giriş izni verilmedi. Devam etmek için erişime izin vermeniz gerekiyor."],
  ["otp_expired", "Doğrulama kodunun süresi doldu. Lütfen yeni bir kod isteyin."],
  ["server_error", "Giriş sağlayıcısında geçici bir sorun oluştu. Lütfen tekrar deneyin."],
  [
    "temporarily_unavailable",
    "Giriş servisi şu anda yanıt vermiyor. Lütfen birazdan tekrar deneyin.",
  ],
  ["invalid_request", "Giriş bağlantısı geçersiz. Lütfen tekrar deneyin."],
  ["unauthorized_client", "Giriş bağlantısı geçersiz. Lütfen tekrar deneyin."],
]);

export const AUTH_GENEL_HATA = "Giriş sırasında bir sorun oluştu. Lütfen tekrar deneyin.";

/**
 * `?error=` kodunu kullanıcıya gösterilecek sabit Türkçe mesaja çevirir.
 *
 * **Her koşulda `string` döner** — bilinmeyen, boş veya prototip adı taşıyan
 * her girdi genel mesaja düşer. Çağıran tarafın ek kontrol yapması gerekmez.
 */
export function authErrorMessage(kod: string | null | undefined): string {
  if (!kod) return AUTH_GENEL_HATA;
  return MESAJLAR.get(kod) ?? AUTH_GENEL_HATA;
}
